import styled from '@emotion/styled';

const StyledForm = styled.form`
  display: flex;
  gap: 12px;
  background-color: #fff;
`;

export { StyledForm };
